<template>
    <div class="footer">
        <p v-if="showDisclaimer" class="disclaimer text-caption" :class="disclaimerClass">
            {{ $t("footer.disclaimer")}}
        </p>
        <crvCooperationLogo v-else />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import crvCooperationLogo from '../assets/logo/crvCooperationLogo.vue';

export default defineComponent({
    name: "SireFooter",
    components: { crvCooperationLogo },
    props: {
        showDisclaimer: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        disclaimerClass() {
            return this.$vuetify.display.smAndDown ? 'mobile' : ''
        }
    }
});
</script>

<style lang="scss" scoped>

.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 20px;
    width: 100%;
    margin-top: 0;
    margin-bottom: 12px;
    padding: 0 48px;

    @include mobile {
        justify-content: center;
        margin-top: $vertical-spacing-single;
    }
}

.disclaimer {
    text-align: center;
    vertical-align: middle;
    display: table-cell;
    margin: 0 75px;

    &.mobile {
        margin: 0 0 20px;
    }
}

.crv-cooperation-logo {
    width: 139px;
    height: 52px;
    display: inline-block;
    fill: #7f746f;

    @include mobile {
        width: 120px;
    }

    display: flex;
}

svg:not(:root) {
    overflow: hidden;
}

</style>